import { Card, Empty } from "antd";
import React from "react";
import { Axis, Chart, Geom, Tooltip } from "bizcharts";

export default function DashboardHabitIndexTrend(props: {
	feed_forward_quarterly_stats: Array<{
		year: number;
		quarter: 1 | 2 | 3 | 4;
		total_lhp_records: number;
		trust_nps_avg: number | null;
		habit_index_avg: number | null;
	}>;
}) {
	const feedforwardQs = props.feed_forward_quarterly_stats.filter(
		(e) => e.total_lhp_records >= 5
	);
	const emptyText = (
		<Empty
			style={{ paddingTop: 10, height: 165 }}
			description={<span>Not enough data yet to display results</span>}
		/>
	);
	if (feedforwardQs.length===0) {
		return (
			<Card title='Habit Index Trend'>
				<Chart
					height={300}
					padding={[30, 70, 30, 90]}
					forceFit={true}
					placeholder={emptyText}
				>
					<Tooltip />
					<Axis name='habit_index_avg' />
				</Chart>
			</Card>
		);
	}
	else {
let trends = feedforwardQs.map((e) => ({
	...e,
	index: e.year * 4 + e.quarter,
}));
trends.sort((a, b) => a.index - b.index);
trends.forEach((e, index) => (e.index = index));

/**
 * https://github.com/alibaba/BizCharts/blob/master/doc/api/scale.md
 */
const makeScale = (tickCount: number) => {
	return {
		index: {
			alias: "Quarter",
			formatter: function (index: number) {
				const item = trends[index];
				return `Q${item.quarter} ${item.year}`;
			},
			type: "linear",
			nice: false,
			tickCount: Math.max(2, tickCount),
		},
		habit_index_avg: {
			alias: "Habit Index",
			min: 0,
			max: 100,
		},
	};
};

return (
	<Card title='Habit Index Trend'>
		<Chart
			height={300}
			padding={[30, 70, 30, 90]}
			forceFit={true}
			data={trends}
			scale={makeScale(trends.length)}
		>
			<Tooltip />
			<Axis name='habit_index_avg' />
			<Geom
				type='line'
				position='index*habit_index_avg'
				color='#4FAAEB'
				size={2}
				shape='smooth'
				tooltip={[
					"index*habit_index_avg",
					(index, habit_index_avg) => {
						return {
							value: `Habit Index: ${habit_index_avg}<br/>No. of members: ${trends[index].total_lhp_records}`,
						};
					},
				]}
			/>
		</Chart>
	</Card>
);
	}
	
}
